<template>
    <div class="vhomeBox"  id="vhomeBox">
        <!--    左侧-->


        <div class="contentLeft">
            <reportList  ref="rptlist" @loadRptList="loadRptList"  :rptlist="rptList" :importlist="importList" @hisNodeClick="selectedHisReport" @handleNodeClick="selectedReport" ></reportList>

        </div>
        <div class="contentRight contetnShadow " >
            <spread ref="spread_view"  @uphis="upHisList"> </spread>
        </div>



    </div>


</template>

<script>
    // import * as API from "./api"


    import * as jUtil from '@/utils/gcExcelJs.js';
    import $ from 'jquery';
    import reportList from "./inputList"; // 左侧-模块

    import spread from "../res/spread"; // spread
    export default {
        name: "reportView",
        components: {

            reportList,
            spread,

        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        data() {
            return {
                rptJson:{},
                rptList:[],
                rptParm:{fid:"",file_json:"",file_type:"rpt",filename:""},
                importList:[],


            };
        },



        activated(){
            this.onResize();
        },

        mounted() {
            this.onResize();

        },

        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $('.contentRight').width(n.w  - $('.contentLeft').width() - 5 );
                $('.contentRight').height(n.h  - 4 );
                this.$refs.spread_view.onResize();
            },


            selectedReport(item){
                this.rptParm= {
                    fid:item.path,
                    filename:item.label,
                    importid:-1,
                    level:0,
                    editState :-2
                };
                this.$refs.spread_view.addTab(this.rptParm);
                this.loadImportList(item.path);

            },
            selectedHisReport(item){
                let args={parmLoad:1};
                if (item.hasOwnProperty("vc_args") && item.vc_args.length>0)
                    args= JSON.parse(item.vc_args);
                    args.update=1;
                this.rptParm= {
                    fid:item.vc_fid,
                    filename:item.title,
                    importid:item.i_id,
                    arg:args,
                    level:1,
                    editState : item.i_state
                };
                this.$refs.spread_view.addTab(this.rptParm);



            },
            async  loadImportList() {
                let _this=this;
                let res = await jUtil.loadImportList(this.rptParm);
                if (res.code==1) {
                    _this.importList=res.data;
                }
                else {
                    this.$refs.mydialog.showDialog({type:"error",text:this.$t('report_report_retrieval_failed')+"!("+res.message+")",info:res.error});
                }
            },
            loadData(id){
                if (id==0)
                {
                    this.editState =true;
                }
                this.rptParm.importid=id>-1?id:-1;
                let args=this.$refs.spread_Edit.getArgsObj();
                this.rptParm.arg=args;
                this.loadReportData();
            },

            async  loadRptList() {
                let _this=this;
                let res = await jUtil.loadReportList(this.rptParm);
                if (res.code==1) {

                    _this.rptList=res.data;

                    this.$refs.rptlist.setRptList(this.rptList);
                }
                else {
                    this.$refs.mydialog.showDialog({type:"error",text:this.$t('report_report_retrieval_failed')+"!("+res.message+")",info:res.error});
                }
            },
            upHisList(data,delid){
                if (delid==0) {
                    const index =this.importList.findIndex((item => item.i_id == data.i_id));
                    if (index == -1) {
                        this.importList.unshift(data);
                    }

                    this.$refs.rptlist.selectHisNode(data.i_id);
                }
                else {
                    const index =this.importList.findIndex((item => item.i_id == delid));
                    if (index !== -1) {
                        this.importList.splice(index, 1);
                    }
                    let ob = this.importList[this.importList.length > index ? index : 0];
                    this.$refs.rptlist.selectHisNode(ob.i_id);
                }
            },


            btn(id){
                switch (id) {
                   case 'collect':
                        $('#collect').hide();
                        $('#expend').show();
                        $('.contentLeft').hide();
                        $('.contentLeft').width(0);
                        this.onResize();
                        break;
                    case 'expend':
                        $('#expend').hide();
                        $('#collect').show();
                        $('.contentLeft').show();
                        $('.contentLeft').width(260);
                        this.onResize();

                        break;
                    default: break;
                }
            },
        },
    }
</script>


<style lang="scss" >

    .vhomeBox {
        margin-top: 0px;
        height: calc(100% - 1px);
        width: 100%;


        .contentLeft {
            float: left;
            width: 260px;
            height: calc(100% - 1px);
            border-bottom: 1px solid #d5d7da;
            border-right: 1px solid #d5d7da;
            z-index: 100;

        }

        .contentRight {
            float: left;
            height: calc(100% - 1px);
            border-bottom: 1px solid #d5d7da;
            z-index: 1000;
        }
    }

    .ul_list {
        height:40px;
        .li {
            margin-top:10px ;
            height: 20px;
            float: left;
            display: block;
        }
    }
</style>

